<div ref="manage_workflow" :key="componentKey">
  <div class="px-3">
    <div class="card-header glassy-bg border-0 shadow-lg mt-2 rounded-top-lg ms-2 mb-4">
      <div class="d-flex justify-content-between align-items-center">
        <!-- Left Side: Founder Info -->
        <div class="d-flex align-items-center">
          <i class="bx bx-user fs-4 text-dark me-2"></i>
          <div class="d-flex flex-column justify-content-center">
            <p class="fw-bold text-dark mb-0 text-x">{{ entity_name }}</p>
            <div class="d-flex align-items-center gap-2">
              <span class="text-xs fw-bold" :style="{ color: get_status_color(application_status) }">
                {{ application_status }}
              </span>

              <span v-if="is_master_registered && display_trust_number" class="badge text-xs fw-bold px-2 py-1" :style="{
                    backgroundColor: get_status_color(application_status) + '20',
                    color: get_status_color(application_status),
                    border: `1px solid ${get_status_color(application_status)}`
                }">
                TRUST: {{ display_trust_number }}
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end align-items-center">
          <!-- Assignments -->
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow-sm text-dark me-2 d-none"
            @click="redirect_to_assignments"
          >
            Assignments
          </button>

        </div>
      </div>
    </div>

    

    <div v-for="section in orderedSections" :key="section.key" class="px-2">
      <!-- PROFILE INFORMATION -->
      <div v-if="section.key === 'profile'" class="file-folder-card mb-1 mt-3">
        <div class="file-folder-header"
             :class="{ 'expanded': openSections.profile }"
             @click="toggleSection('profile')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <div class="file-folder-icon me-3">
                <i class="bi bi-person-badge fs-2 text-primary-green"></i>
              </div>
              <div>
                <h6 class="mb-0 fw-bold text-white">PROFILE INFORMATION</h6>
                <small class="text-white">Captured profile data and submitted profile documents</small>
              </div>
            </div>
            <div class="file-folder-actions">
              <i class="bi fs-2 text-white" :class="openSections.profile ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>
          </div>
        </div>

        <div class="collapse border border-dark bg-white" :class="{ show: openSections.profile }">
          <div class="file-folder-body p-3">
            <div v-if="profile_sections.length === 0" class="text-muted text-xs">No profile form data available.</div>

            <div v-for="profile_section in profile_sections" :key="profile_section.id" class="mb-4">
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th class="text-xxs">Question</th>
                      <th class="text-xxs">Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="question in profile_section.questions" :key="question.section_question_id">
                      <td class="text-xxs">{{ question.question_text }}</td>
                      <td class="text-xxs">
                        <span v-if="typeof question.answer === 'object' && question.answer?.file_name">
                          {{ question.answer.file_name }}
                        </span>
                        <span v-else>
                          {{ question.answer || '-' }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- ONBOARDING INFORMATION -->
      <div v-if="section.key === 'onboarding'" class="file-folder-card mb-1 mt-3">
        <div class="file-folder-header"
             :class="{ 'expanded': openSections.onboarding }"
             @click="toggleSection('onboarding')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <div class="file-folder-icon me-3">
                <i class="bi fs-2" :class="openSections.onboarding ? 'bi-person-vcard text-primary-green' : 'bi-person-vcard text-primary-green'"></i>
              </div>
              <div>
                <div>
                  <h6 class="mb-0 fw-bold text-white">
                    {{ hostname.includes('x-verdict') ? 'Case Facts' : 'Job Information' }}
                  </h6>

                  <small class="text-white">
                    {{ hostname.includes('x-verdict') ? 'View and manage case-specific details' : onboarding_description }}
                  </small>
                </div>
              </div>
            </div>
            <div class="file-folder-actions">
              <i class="bi fs-2 text-white" :class="openSections.onboarding ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>
          </div>
        </div>

        <div class="collapse border border-dark" :class="{ show: openSections.onboarding }">
          <div class="overview-application-container p-3">
            <!-- Scrollable Floating Tabs -->
            <div class="overview-tabs-wrapper overview-scrollable-container">
              <div class="overview-vertical-tabs-container">
                <div
                  v-for="tab in visible_tabs_clean"
                  :key="tab.id"
                  class="overview-floating-tab rounded-lg"
                  :class="{ active: active_tab === tab.id }"
                  @click="select_tab(tab.id)"
                  :data-tooltip="tab.name"
                >
                  <div class="overview-floating-tab-inner">
                     <div class="d-flex align-items-center w-100 gap-2">
                      <!-- Dynamic Icon -->
                      <i
                        class="me-2 fs-bold fs-6"
                        :class="get_tab_icon(tab.id)"
                      ></i>
 
                      <span class="text-xs fw-semibold overview-tab-label">
                        {{ tab.name }}
                      </span>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
            <!-- Dropdown Section -->
            <div class="ms-2 overview-dropdown-column rounded-lg" v-if="active_tab_has_dropdown">
              <div class="overview-accordion-container mb-3 border-0 rounded-lg glassy-bg" id="stages_accordion">

                <div
                  v-for="option in active_tab_dropdown_options"
                  :key="option.value"
                  class="accordion-item bg-transparent"
                >

                  <div class="collapse" :class="{ show: selected_dropdown === option.value }">
                    <div class="accordion-body bg-transparent p-3">

                      <div v-if="is_db_main_section_tab(selected_dropdown)">
                        <RenderSections
                          :form_main_section_id="dropdown_forms_id(selected_dropdown)"
                          :application_id="application_id"
                          :application_form_id="application_form_id"
                          :entity_profile_id="entity_profile_id"
                          :current_status_id="current_status_id"
                          @files-saved="handleFilesSaved"
                        />
                      </div>

                      <div v-if="selected_dropdown === 'Overview'">
                        <ApplicationVerification
                          @status-updated="handle_status_updated"
                          @trust-number-updated="handle_trust_number_updated"
                        />
                      </div>

                      <div v-if="selected_dropdown === 'Attributes'">
                        <ApplicationAttributes
                          :application-id="application_id"
                          :entity-profile-id="entity_profile_id"
                        />
                      </div>

                      <div v-if="selected_dropdown === 'Verification'">
                        <VerificationOverview :application_form_id="application_form_id" />
                      </div>

                      <div v-if="selected_dropdown === 'E-Signing'">
                        <ESigning :application_id="application_id" />
                      </div>

                      <div v-if="selected_dropdown === 'Asset Registry'">
                        <AssetsRegistry
                          :application-id="application_id"
                          :entity-profile-id="entity_profile_id"
                          :entity-type-id="entity_type_id"
                          :project-id="project_id"
                          :parent-entity-type-id="entity_type_id"
                          @asset-created="handleAssetCreated"
                          @view-asset="redirectToAssetProfile"
                        />
                      </div>

                      <div v-if="selected_dropdown === 'Requests'">
                        <ViewRequests />
                      </div>

                      <div v-if="selected_dropdown === 'Journal'">
                        <ApplicationJournal
                        @files-saved="handleFilesSaved" />
                      </div>

                      <!-- Child Entity Type Tab Content -->
                      <div v-if="is_child_entity_type_tab(selected_dropdown)">

                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <p class="mb-0 fw-bold text-dark text-x">
                            {{ child_tab_title(selected_dropdown) }}
                          </p>

                          <button
                            @click="open_add_sub_entity_from_child_tab(selected_dropdown)"
                            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                          >
                            Add {{ child_tab_title(selected_dropdown) }}
                          </button>
                        </div>

                        <FolderList
                          v-if="child_tab_items(selected_dropdown).length > 0"
                          :items="child_tab_items(selected_dropdown)"
                          @view="redirect_to_application_overview"
                          @add-sub="handle_folderlist_add"
                          @fetch-assigned="fetch_assigned_for_item"
                          :moving_to_master_loading="false"
                        />

                        <div v-else class="text-center py-5 text-muted">
                          <i class="fa-solid fa-inbox fa-3x mb-3"></i>
                          <p>No {{ child_tab_title(selected_dropdown) }} found</p>
                        </div>

                      </div>

                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- DOCUMENTS --->
      <div v-if="section.key === 'documents'" class="file-folder-card mb-1 mt-3">
        <div class="file-folder-header"
             :class="{ 'expanded': openSections.documents }"
             @click="toggleSection('documents')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <div class="file-folder-icon me-3">
                <i class="bi fs-2" :class="openSections.documents ? 'bi-file-text text-primary-green' : 'bi-file-text text-primary-green'"></i>
              </div>
              <div>
                <h6 class="mb-0 fw-bold text-white">
                    {{ hostname.includes('x-verdict') ? 'Case Evidence' : 'Document Vault' }}
                </h6>

                <small class="text-white">
                    {{ hostname.includes('x-verdict') ? 'Upload files and manage your case-specific documents' : 'Uploaded files , documents , Z83 forms' }}
                </small>

              </div>
            </div>
            <div class="file-folder-actions">
              <i class="bi fs-2 text-white" :class="openSections.documents ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>
          </div>
        </div>

        <div class="collapse" :class="{ show: openSections.documents }">
          <div class="file-folder-body border border-dark p-3">
            <DocumentManagement
              :application_form_id="application_form_id"
              :entity_profile_id="entity_profile_id"
              :key="`documents-${application_id}-${document_reload_key}`"
              @files-saved="handleFilesSaved"
            />
          </div>
        </div>
      </div>

      <!-- COMPLIANCE -->
      <div v-if="section.key === 'compliance'" class="d-none file-folder-card mb-1 mt-3">
        <div class="file-folder-header"
             :class="{ 'expanded': openSections.compliance }"
             @click="toggleSection('compliance')">
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="d-flex align-items-center">
              <div class="file-folder-icon me-3">
                <i class="bi fs-2" :class="openSections.compliance ? 'bi bi-card-checklist text-primary-green' : 'bi bi-card-checklist text-primary-green'"></i>
              </div>
              <div>
                <h6 class="mb-0 fw-bold text-white">
                    {{ hostname.includes('x-verdict') ? 'Case Compliance' : 'Compliance Checks' }}
                </h6>
                <small class="text-white">Monitor compliance status, and ensure regulatory adherence</small>
              </div>
            </div>
            <div class="file-folder-actions">
              <i class="bi fs-2 text-white" :class="openSections.compliance ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </div>
          </div>
        </div>

        <div class="collapse" :class="{ show: openSections.compliance }">
          <div class="file-folder-body border border-dark p-3">
              <ComplianceProfileTabs
                :tabs="compliance_tabs"
                :dropdown-options="compliance_dropdown_options"
              >
                <template #content="{ tab, section }">
                  <OnboardingComplianceComponent
                    v-if="tab === 'onboarding' && section === 'onboardingcompliance'"
                    :entity_profile_id="entity_profile_id"
                    @compliance-loaded="handleComplianceLoaded"
                  />
                  <!-- Ongoing Compliance - Use EntityComplianceAnswers -->
                  <EntityComplianceAnswers
                    v-if="tab === 'ongoing' && section === 'ongoingcompliance'"
                    :entity_profile_id="entity_profile_id"
                    @data-loaded="handleComplianceLoaded"
                  />
                  <CaseComplianceOverview
                    v-if="tab === 'caseoverview' && section === 'caseoverview' && hostname.includes('x-verdict')"/>
                  <ComplianceOverview
                    v-if="tab === 'overview' && section === 'complianceoverview' && hostname.includes('trustfirst')"
                  />
                </template>
              </ComplianceProfileTabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Assign Sub Entity Modal -->
<teleport to="body">
  <div class="modal fade" id="assign_sub_entity_modal" tabindex="-1" aria-labelledby="assign_sub_entity_modal_label"
    aria-hidden="true" ref="assignSubEntityModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header cute-header d-flex align-items-center justify-content-between px-3 py-2">
          <h5 class="modal-title text-white text-xxs m-0" id="assign_sub_entity_modal_label">Add Sub-Entity</h5>
          <button type="button" class="btn-close modal-btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <!-- Body -->
        <div class="modal-body p-3">
          <!-- Main Entity (readonly for context) -->
          <div class="modal-form-group form-group mb-3">
            <label class="modal-form-label form-label text-xxs">Parent Entity Type</label>
            <input type="text" class="modal-form-control form-control text-xxs"
              :value="current_form.parent_name || 'Loading...'" disabled>
          </div>

          <!-- Sub-Entity Type (under the selected parent) -->
          <div class="modal-form-group form-group mb-3">
            <label for="assign_sub_entity_type" class="modal-form-label form-label text-xxs">Sub-Entity Type</label>
            <select id="assign_sub_entity_type"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_sub_entity_type_id" @change="assign_on_sub_entity_change"
              :disabled="assign_sub_entity_options.length === 0 || is_loading_options">
              <option value="" disabled selected>Select sub-entity type</option>
              <option v-for="opt in assign_sub_entity_options" :key="opt.id" :value="opt.id">
                {{ opt.name }}
              </option>
            </select>
            <div v-if="is_loading_options" class="text-info text-xxs mt-1">
              <i class="fas fa-spinner fa-spin me-1"></i>Loading sub-entity types...
            </div>
            <div v-if="assign_sub_entity_options.length === 0 && !is_loading_options" class="text-danger text-xxs mt-1">
              No sub-entity types available for this parent entity.
            </div>
          </div>

          <!-- Forms (populated from the chosen sub-entity type) -->
          <div class="modal-form-group form-group mb-3" v-if="assign_form_list.length">
            <label for="assign_form_select" class="modal-form-label form-label text-xxs">Form</label>
            <select id="assign_form_select"
              class="modal-form-select form-select text-xs rounded-small p-2 shadow-sm text-x"
              v-model="assign_selected_form_id" :disabled="assign_form_list.length === 0">
              <option value="" disabled selected>Select form</option>
              <option v-for="form in assign_form_list" :key="form.id" :value="form.id">
                {{ form.form_name }}
              </option>
            </select>
          </div>
          <div class="modal-form-group form-group mb-3" v-else-if="assign_sub_entity_type_id">
            <label class="modal-form-label form-label text-xxs">Form</label>
            <div class="alert alert-info text-xxs p-2">
              Select a sub-entity type to see available forms
            </div>
          </div>

          <!-- Sub-Entity Name -->
          <div class="modal-form-group form-group mb-3">
            <label for="assign_entity_name" class="modal-form-label form-label text-xxs">Sub-Entity Name</label>
            <input id="assign_entity_name" type="text" v-model="assign_entity_name"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter Sub-Entity Name">
          </div>

          <!-- Toggle for showing the email field -->
          <div class="modal-form-group form-group mb-3">
            <div class="form-check form-switch text-xxs d-flex justify-content-start align-items-center">
              <input type="checkbox" id="email_toggle" v-model="include_email" class="form-check-input" role="switch">
              <label class="form-check-label ms-2" for="email_toggle">
                Allow login - Create user account with email invitation
              </label>
            </div>
            <small class="form-text text-muted text-xxs">
              When enabled, the entity will be able to log in and complete their own forms
            </small>
          </div>

          <!-- Email -->
          <div class="modal-form-group form-group mb-3" v-if="include_email">
            <label for="assign_email" class="modal-form-label form-label text-xxs">Email</label>
            <input id="assign_email" type="email" v-model="assign_email"
              class="modal-form-control form-control text-xs rounded-small p-2 shadow-sm text-x"
              placeholder="Enter Email">
          </div>

          <!-- Footer -->
          <div class="modal-footer border-0 p-2 d-flex justify-content-end">
            <button type="button" class="btn btn-primary-dark btn-sm px-3 text-xxs shadow-sm"
              @click="save_assign_sub_entity">
              <span v-if="isSaving">
                <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                Saving...
              </span>
              <span v-else>Save</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
